export const hajjConst = [
    {
        labels: [
            "Select Account Number",
            "Enter Payment Code",
            "Search",
            "Amount",
            "Service Package",
            "Payment Code",
            "Continue",
            "Pilgrim name"
        ],
    },
    {
        
        labels: [
            "የሂሳብ ቁጥር ይምረጡ", 
            "የግብይት ማጣቀሻ አስገባ", 
            "ፈልግ", 
            "መጠን", 
            "የአገልግሎት ጥቅል", 
            "የግብይት ማጣቀሻ", 
            "ቀጥል", 
            "የሑጃጅ ስም"
        ],
    },
    {
        
        labels: [
            "Lakkoofsa Herregaa Filadhu", 
            "Mallattoo Walqabsiistaa Galchaa", 
            "Barbaadi", 
            "Baay'ina", 
            "Paakeejii Tajaajilaa", 
            "Mallattoo Walqabsiistaa", 
            "Itti Fufi", 
            "Maqaa Hajjii" 
        ],
    },
    {
        
        labels: [
            "ቁጽሪ ሕሳብ ምረጽ", 
            "ዋዕላ ግብሪ ኣእትው", 
            "ድለ", 
            "ጠቕላላ ድምር", 
            "ፓኬጅ ኣገልግሎት", 
            "ዋዕላ ግብሪ", 
            "ቀጽል", 
            "ሽም ሓጃጅ" 
        ],
    },
    {
        
        labels: [
            "Xisaab Nambarka Dooro", 
            "Tixraac Ganacsiga Geli", 
            "Raadi", 
            "Qadarka", 
            "Xirmada Adeegga", 
            "Tixraac Ganacsiga", 
            "Sii Soco", 
            "Magaca Xajiga" 
        ],
    },
    {
        
        labels: [
            "Hisab Nummara Yokale", 
            "Gexsi Yameete", 
            "Gexso", 
            "Qadaana", 
            "Nabada Yakme", 
            "Station Yascasse", 
            "Itteh", 
            "Qilba Yascasa", 
        ],
    },
];